import { render, staticRenderFns } from "./InfoTabs.vue?vue&type=template&id=7d609b86&scoped=true&"
import script from "./InfoTabs.vue?vue&type=script&lang=js&"
export * from "./InfoTabs.vue?vue&type=script&lang=js&"
import style0 from "./InfoTabs.vue?vue&type=style&index=0&id=7d609b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d609b86",
  null
  
)

export default component.exports